import React from "react";
import { formatDateMDDYYYY } from "../utils/Date.util";

const BlogStyle3 = ({ post, skeleton }) => {
    if (skeleton) {
        return (
            <div className="blog-style3" style={{ height: "100%" }}>
                <div
                    className="bg-light ratio ratio-16x9"
                    style={{ height: "100%" }}
                ></div>
                <div className="blog-content">
                    <div
                        data-theme-color="#007BFF"
                        className="category"
                        style={{
                            backgroundColor: "#e41917",
                            width: "55px",
                            height: "26px",
                        }}
                    ></div>
                    <h3
                        className="bg-secondary box-title-30"
                        style={{ width: "75%", height: "35px" }}
                    ></h3>
                    <div className="d-flex gap-3 blog-meta">
                        <div
                            className="bg-secondary"
                            style={{
                                width: "113px",
                                height: "26px",
                            }}
                        ></div>
                        <div
                            className="bg-secondary"
                            style={{
                                width: "113px",
                                height: "26px",
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="blog-style3" style={{ height: "100%" }}>
            <div className="blog-img" style={{ height: "100%" }}>
                <img
                    src={`${process.env.REACT_APP_REDLINES_IMAGE_STORAGE}/${post.featured_image}`}
                    alt={post.title}
                    style={{ height: "100%" }}
                />
            </div>
            <div className="blog-content">
                <a
                    data-theme-color="#007BFF"
                    href={`/category/${post.categories[0].name}`}
                    className="category"
                >
                    {post.categories[0].name}
                </a>
                <h3 className="box-title-30">
                    <a className="hover-line" href="blog-details.html">
                        {post.title}
                    </a>
                </h3>
                <div className="blog-meta">
                    <p>
                        <i className="far fa-user"></i>
                        By - {post.author_id}
                    </p>
                    <p>
                        <i className="fal fa-calendar-days"></i>
                        {formatDateMDDYYYY(post.created_at)}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BlogStyle3;
